import React, {useMemo} from "react";
import { Select, DatePicker, Row, Col, Card } from "antd";
import countryList from 'react-select-country-list'


const LoginDetails = ({ courseList }) => {

  const options = useMemo(() => countryList().getData(), [])
  // Debugging to ensure props are arriving correctly
  console.log("course List", courseList);

  const handleGradeChange = (value) => {
    console.log(`Selected Grade ID: ${value}`);
    // You can call a prop function here to filter the courses in the parent component
  };

  return (
    <div className="login-details-container p-4">
      <Row gutter={[32, 32]}>
        {/* Left Section: Form Inputs */}
        <Col xs={24} lg={14}>
          <div className="form-group mb-4">
            <label className="d-block mb-2 text-muted">The type of school your student will be attending</label>
            <Select
              placeholder="Select school type..."
              className="w-100"
              size="large"
              options={[
                { value: "home", label: "Home School" },
                { value: "public", label: "Public School" },
                { value: "private", label: "Private School" },
              ]}
            />
          </div>

          <div className="form-group mb-4">
            <label className="d-block mb-2 text-muted">The county your student resides in</label>
            <Select
              placeholder="Select county..."
              className="w-100"
              size="large"
              options={options?.map( item => ({
                label: item?.label,
                value: item?.value
              }))}
            />
          </div>

          <div className="form-group mb-4">
            <label className="d-block mb-2 text-muted">The school your student will attend</label>
            <Select
              placeholder="Select school..."
              className="w-100"
              size="large"
              options={[{ value: "high-school-a", label: "High School A" }]}
            />
          </div>

          <Row gutter={16}>
            <Col span={12}>
              <div className="form-group">
                <label className="d-block mb-2 text-muted">Your student's grade</label>
                <Select
                  placeholder="Select grade..."
                  className="w-100"
                  size="large"
                  onChange={handleGradeChange}
                  // Map the courseList prop to Ant Design Select options
                  options={courseList?.map((item) => ({
                    value: item.id,   // Course ID
                    label: item.title // Course Title (e.g., "LKG", "1st")
                  }))}
                />
              </div>
            </Col>
            <Col span={12}>
              <div className="form-group">
                <label className="d-block mb-2 text-muted">Preferred Start Date</label>
                <DatePicker 
                  className="w-100" 
                  size="large" 
                  placeholder="MM/DD/YYYY"
                  format="MM/DD/YYYY"
                />
              </div>
            </Col>
          </Row>

          <div className="mt-5">
            <p className="text-danger font-weight-bold" style={{ fontSize: '14px' }}>
              Please select your courses below. You can sign up for up to six (6) courses at a time. 
              Each course selection will default to the full course (both segments) unless otherwise noted.
            </p>
          </div>
        </Col>

        {/* Right Section: Sidebar (UI remained the same) */}
        <Col xs={24} lg={10}>
          <Card className="bg-light border-0 rounded-lg shadow-sm">
            <h5 className="mb-4">Wondering what a segment is?</h5>
            <div className="segment-logic-box d-flex align-items-center justify-content-between mb-4 p-3 bg-white border rounded">
              <div className="segment-tag px-3 py-2 text-center" style={{ backgroundColor: '#fdeaea', color: '#b22222', borderRadius: '4px' }}>
                Segment 1
              </div>
              <span className="mx-2">+</span>
              <div className="segment-tag px-3 py-2 text-center" style={{ backgroundColor: '#fdeaea', color: '#b22222', borderRadius: '4px' }}>
                Segment 2
              </div>
              <span className="mx-2">=</span>
              <div className="course-tag px-3 py-2 text-white text-center" style={{ backgroundColor: '#b22222', borderRadius: '4px' }}>
                Course
              </div>
            </div>
            <div className="info-text text-muted" style={{ fontSize: '13px', lineHeight: '1.6' }}>
              <p>A segment typically represents one semester of a full-year course...</p>
            </div>
            <div className="mt-4 overflow-hidden rounded">
              <img 
                src="https://images.unsplash.com/photo-1507842217343-583bb7270b66?auto=format&fit=crop&q=80&w=600" 
                alt="Library" 
                className="img-fluid w-100"
                style={{ height: '180px', objectFit: 'cover' }}
              />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default LoginDetails;